export const TEMPLATE_PARAM_TEXT = 1;
export const TEMPLATE_PARAM_DATE = 2; 